export { TITLE_MAX_LENGTH } from "@hex/common";

export const DEFAULT_PROJECT_TITLE = "Untitled project";
export const DEFAULT_COMPONENT_TITLE = "Untitled component";
export const DEFAULT_THREAD_TITLE = "New thread";
export const PROJECT_METADATA_PADDING = 3;
